import { z } from 'zod';

import { AddressFieldsFormFields } from 'src/constants/address';
import {
  feinZodValidationSchema,
  phoneNumberZodValidationSchema,
  taxYearEndDateSimpleZodValidationSchema,
  zipCodeZodValidationSchema,
} from 'src/constants/validation';
import { selectFieldOptionValidationSchema } from 'src/constants/validation/form';

import {
  PeoPayrollProviderCompanyInformationFormFields,
  PeoPayrollProviderCompanyInformationFormValues,
} from '../types';

export const peoPayrollProviderCompanyInformationFormValidationSchema = z.object({
  [PeoPayrollProviderCompanyInformationFormFields.displayName]: z.string(
    'Required company display name',
  ),
  [PeoPayrollProviderCompanyInformationFormFields.fein]: feinZodValidationSchema,
  [PeoPayrollProviderCompanyInformationFormFields.industry]:
    selectFieldOptionValidationSchema.nullish(),
  [PeoPayrollProviderCompanyInformationFormFields.taxYearEndDate]:
    taxYearEndDateSimpleZodValidationSchema,
  [PeoPayrollProviderCompanyInformationFormFields.numberOfEmployees]: z
    .int('Invalid value')
    .positive()
    .nullish(),
  [PeoPayrollProviderCompanyInformationFormFields.corporateStructure]: z.string().nullish(),
  [PeoPayrollProviderCompanyInformationFormFields.contactPhoneNumber]:
    phoneNumberZodValidationSchema,
  [PeoPayrollProviderCompanyInformationFormFields.contactEmail]: z.email('Required contact email'),
  [PeoPayrollProviderCompanyInformationFormFields.defaultDisclaimer]: z.string().nullish(),
  [PeoPayrollProviderCompanyInformationFormFields.headquarters]: z.object({
    [AddressFieldsFormFields.street]: z.string('Required street'),
    [AddressFieldsFormFields.city]: z.string('Required city'),
    [AddressFieldsFormFields.county]: z.string().nullable(),
    [AddressFieldsFormFields.state]: z.string('Required state'),
    [AddressFieldsFormFields.zipCode]: zipCodeZodValidationSchema,
  }),
}) satisfies z.ZodType<PeoPayrollProviderCompanyInformationFormValues>;
